import * as VueRouter from 'vue-router';
import routes from './routes';

const router = VueRouter.createRouter({
  history: VueRouter.createWebHistory(process.env.VUE_APP_BASE),
  routes, // short for `routes: routes`
})

export default router;